module.exports = __webpack_public_path__ + "img/brands-mulino-bianco-logo.png?9a30f2b912557ce7fc46c2839aa4e83a";